<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <stock-show-data :item="item" />
        </v-card-text>



  </crud-show>
</template>

<script>
    import StockShowData from "./StockShowData";
    import {CrudShow} from '@dracul/common-frontend'

    export default {
        name: "StockShow",
        components: {CrudShow, StockShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.stock.showing',
            }
        },
    }
</script>

